<template>
  <div class="by-multiple-select" v-clickoutside="closePanel">
    <div :class="{ 'by-select-input': true, 'by-panel-input__active': panelShow }" @click="panelShow = !panelShow">
      <!-- <svg-icon
        v-if="labelIcon"
        :name="labelIconName"
        :size="14"
        color="#0046B9"
        style="margin-right: 4px"
      ></svg-icon> -->
      <!-- <input readonly v-model="text" /> -->
      <!-- <span :class="{ 'span-active': text }">{{ text || placeholder }}</span> -->
      <span :class="{ 'span-active': false }">{{ text || placeholder }}</span>
      <!-- @click="panelShow = !panelShow" -->
      <i
        :class="{
          'el-icon-arrow-down': true,
          'icon-rotate-open': panelShow,
          'icon-rotate-close': !panelShow,
          'span-active': false,
        }"
      ></i>
    </div>
    <el-collapse-transition>
      <div
        class="by-panel"
        v-show="panelShow"
        @mouseenter="panelOpen = true"
        @mouseleave="panelOpen = false"
      >
        <div class="by-panel-list">
          <div class="by-panel-item" @click="handlerAllClick()" v-if="isAll">
            <span
              :class="{
                'active-color': value.length == list.length,
                'margin-right_16': true,
              }"
            >
              全部
            </span>
            <img
              v-if="value.length == list.length"
              src="@/assets/img/client/check/icon_ic_xp_selected@2x.png"
              width="16px"
              height="16px"
              alt="checked"
            />
            <img
              v-else
              src="@/assets/img/client/check/icon_ic_xp_selected_normal@2x.png"
              width="16px"
              height="16px"
              alt="normal"
            />
          </div>
          <div
            class="by-panel-item"
            v-for="item in list"
            :key="item[modelKey]"
            @click="handlerClick(item)"
          >
            <span
              :class="{
                'active-color':
                  (isAll ? (value.length < list.length) : true) && value.includes(item[modelKey]),
                'margin-right_16': true,
              }"
              >{{ labelName(labelKeys, item) }}</span
            >
            <img
              v-if="
                (isAll ? (value.length < list.length) : true) && value.includes(item[modelKey])
              "
              src="@/assets/img/client/check/icon_ic_xp_selected@2x.png"
              width="16px"
              height="16px"
              alt="checked"
            />
            <img
              v-else
              src="@/assets/img/client/check/icon_ic_xp_selected_normal@2x.png"
              width="16px"
              height="16px"
              alt="normal"
            />
          </div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
// import SvgIcon from "./SvgIcon.vue";
export default {
  props: {
    type: {
      type: String,
      default: 'multipleLabel', // 选中显示效果， multipleLabel： 显示label 拼接， placeholderNumber: 显示默认显示文字加选中数量
    },
    value: {
      // 输入框绑定值
      // required: true,
      default: () => {
        return []
      },
    },
    modelKey: {
      // 绑定值key
      type: String,
      // required: true,
      default: '',
    },
    list: {
      // 下拉数据
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    labelIcon: {
      // 是否显示图标
      type: Boolean,
      required: false,
      default: false,
    },
    labelIconName: {
      // 图标名称
      type: String,
      required: false,
      default: 'fenlei1',
    },
    labelKeys: {
      // 显示值的key
      type: Array,
      // required: true,
      default: () => {
        return [];
      },
    },
    isInitUpdate: {
      // 初次默认值加载是否需要上传数据
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    remark: {
      // 移上选项是否需要提示
      type: String,
      default: '',
    },
    isAll: {
      // 是否有全选
      type: Boolean,
      default: false,
    },
  },
  components: {
    // SvgIcon,
  },
  data() {
    return {
      panelShow: false,
      panelOpen: false,
      text: '',
    };
  },
  computed: {},
  watch: {
    value: {
      handler(val) {
        if (this.list.length > 0 && val.length >= 0) {
          this.setDefaultValue();
        }
      },
      deep: true,
      immediate: true,
    },
    list: {
      handler(val) {
        // 设置默认显示值
        if (val.length > 0 && this.value.length >= 0) {
          this.setDefaultValue();
        }
      },
      deep: true,
      immediate: true,
    },
    panelShow(val) {
      // 获取组件的聚焦状态
      this.$emit('getFocusStatus', val);
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 设置默认值
    setDefaultValue() {
      if (this.value.length < this.list.length) {
        this.getText(this.value);
      } else if (this.value.length == this.list.length) {
        if (this.type == 'multipleLabel') {
          this.text = '全部';
        } else {
          this.text = this.placeholder + ' ' + this.list.length;
        }
      }
    },
    // label 显示
    labelName(labelKeys, data) {
      let name = '';
      labelKeys.forEach((item) => {
        name += data[item] + ' ';
      });
      return name;
    },
    // 显示勾选文字
    getText(list) {
      let text = [];
      this.list.forEach((item) => {
        if (list.includes(item[this.modelKey])) {
          text.push(this.labelName(this.labelKeys, item));
        }
      });
      if (this.type == 'multipleLabel') {
        this.text = text.join('、');
      } else {
        this.text = this.placeholder + ' ' + (text.length == 0 ? '' : text.length);
      }
    },
    // 选择下拉值
    handlerClick(item) {
      let updateValue = [];
      console.log('value',this.value)
      console.log('list',this.list)
      if (this.value.length < this.list.length) {
        // 判断若是已经选中了，就取消选中，未选中就选中
        if (this.value.includes(item[this.modelKey])) {
          let index = this.value.indexOf(item[this.modelKey]);
          let valueList = this.value;
          valueList.splice(index, 1);
          updateValue = valueList;
        } else {
          updateValue = [...this.value, item[this.modelKey]];
        }

        // 显示勾选项文字
        this.getText(updateValue);
      } else if (this.value.length == this.list.length) {
        updateValue = [item[this.modelKey]];
        if (this.type == 'multipleLabel') {
          this.text = this.labelName(this.labelKeys, item);
        } else {
          this.text = this.placeholder + ' ' + this.list.length;
        }
      }

      // 上传数据
      this.update(updateValue);
    },
    update(list) {
      this.$emit('input', list);
      this.$emit('change', list);
      if (list.length == this.list.length) {
        this.panelShow = false;
      }
    },
    // 全选
    handlerAllClick() {
      let list = [];
      this.list.forEach((item) => {
        list.push(item[this.modelKey]);
      });
      this.update(list);
    },
    // 关闭下拉列表
    closePanel() {
      if (!this.panelOpen) {
        this.panelShow = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.by-multiple-select {
  position: relative;
  .by-select-input {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 128px;
    height: 32px;
    padding: 0 10px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dddddd;
    transition: all 0.3s;
    box-sizing: border-box;
    i {
      display: block;
      font-size: 15px;
      cursor: pointer;
    }
    .icon-rotate-open {
      transition: transform 0.3s;
      transform: rotate(180deg);
    }
    .icon-rotate-close {
      transition: transform 0.3s;
      transform: rotate(0deg);
    }
    span {
      display: inline-block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }

    .span-active {
      color: #0046b9;
    }
    input {
      outline: none;
      border: none;
      width: 88px;
      height: 22px;
      background: transparent;
      position: relative;
      cursor: pointer;
      // 文本溢出省略号
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      font-size: 14px;
      font-family: 'PingFangSC-Regular', 'Microsoft YaHei', sans-serif;
      font-weight: 550;
      color: #333333;
      line-height: 22px;
    }
    input::-webkit-input-placeholder {
      font-size: 14px;
      font-family: 'PingFangSC-Regular', 'Microsoft YaHei', sans-serif;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 22px;
    }
  }

  .by-panel-input__active {
    border: 1px solid #3370ff;
  }
  .by-panel {
    position: absolute;
    z-index: 100;
    top: 120%;
    width: auto;
    min-width: 128px;
    // height: 112px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;

    .by-panel-list {
      padding: 4px;
      box-sizing: border-box;
      height: auto;
      max-height: 300px;
      min-width: 80px;
      overflow-x: hidden;
      overflow-y: auto;

      .by-panel-item {
        // width: 160px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 32px;
        padding: 8px;
        white-space: nowrap;
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;

        &:hover {
          cursor: pointer;
          background: rgba(0, 70, 185, 0.04);
        }

        span {
          display: inline-block;
          font-size: 12px;
          font-family: 'PingFangSC-Regular', 'Microsoft YaHei', sans-serif;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
        }

        .active-color {
          font-family: 'PingFangSC-Medium', 'Microsoft YaHei', sans-serif;
          font-weight: 550;
          color: #3370ff;
        }
      }
    }
  }
}

.by-type-select ::v-deep .by-panel-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.by-type-select ::v-deep .by-panel-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  background: #e0e0e0;
}

.by-type-select ::v-deep .by-panel-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  //  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  // -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  border-radius: 4px;
  background: #fff;
}
</style>
